/** @jsxImportSource @emotion/react */

import { Button } from "components/Button";
import VerticalLogo from "components/Logo/VerticalLogo";
import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import tw from "twin.macro";

export default function ErrorPage({ error: propError }: { error?: unknown }) {
  const navigate = useNavigate();
  const routeError = useRouteError();
  const error = propError ?? routeError;
  let errorMessage: string | null = null;
  if (isRouteErrorResponse(error)) {
    // error is type `ErrorResponse`
    console.log(error.data);
    errorMessage = error.data;
  } else if (typeof error === "string") {
    console.log(error);
    errorMessage = error;
  } else if (error instanceof Error) {
    console.log(error);
    errorMessage = error.message;
  }
  return (
    <div
      css={[
        tw`min-h-full w-full flex flex-col justify-center gap-y-4 mt-10 items-center`,
      ]}
    >
      <VerticalLogo wrapperCss={[tw`w-1/6 m-0`]} withText={false} />

      <h3>Oops!</h3>
      {errorMessage ? errorMessage : <p>Something went wrong.</p>}

      <div css={[tw`font-semibold`]}>
        <Button
          variant="transparent"
          onClick={() => navigate(-1)}
          css={[tw`font-semibold`]}
        >
          Go Back
        </Button>
      </div>
    </div>
  );
}
